var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__a)",
    fillRule: "evenodd",
    d: "M6.5 20c0-7.456 6.044-13.5 13.5-13.5S33.5 12.544 33.5 20 27.456 33.5 20 33.5 6.5 27.456 6.5 20M20 3.5C10.887 3.5 3.5 10.887 3.5 20S10.887 36.5 20 36.5 36.5 29.113 36.5 20 29.113 3.5 20 3.5m1.5 10.25a1.5 1.5 0 0 0-3 0V20c0 .502.25.97.668 1.248l7.5 5a1.5 1.5 0 0 0 1.664-2.496L21.5 19.197z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__a",
    x1: 33.572,
    x2: -32.379,
    y1: 4.411,
    y2: 29.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgClock;